import { AppApiAction } from 'actions/ActionTypes'
import { API_CALL } from 'actions/actionConstants'
import requestGetAccountAgent from 'agentHub/api/requestGetAccountAgent'
import { EMAIL_CHECK_AGENT_STATUS, FETCH_ACCOUNT_AGENT_HUB } from './apiActionConstants'
import requestGetAgentAccountStatus from 'agentHub/api/requestGetAgentStatus'
import requestGetAgentStatusByEmail from 'agentHub/api/requestGetAgentStatusByEmail'

export function fetchAccountAgentHub(): AppApiAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.agentHub.agentHubAccount.data?.status === 'onboarded') {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_ACCOUNT_AGENT_HUB,
      request: () => requestGetAccountAgent(),
    })
  }
}

export function fetchAgentAccountByAgentId(agentId: string): AppApiAction {
  return {
    type: API_CALL,
    api: FETCH_ACCOUNT_AGENT_HUB,
    request: () => requestGetAgentAccountStatus(agentId),
  }
}

export function checkAgentHubStatus(email: string): AppApiAction {
  return {
    type: API_CALL,
    api: EMAIL_CHECK_AGENT_STATUS,
    key: email,
    request: () => requestGetAgentStatusByEmail(email),
  }
}
